import { merge } from 'lodash';

/**
 * Determines if the service has been instanciated.
 * @type {Boolean}
 */
let initialized = false;
/**
 * Stores composed copies of the config passed to {@link setConfig}
 * @type {Object}
 */
let storedConfig = {};

/**
 * Updates the locally stored config. This allows to change the config that
 * will be provided by {@link ChilduppPropertiesService} before it has been
 * instanciated.
 *
 * Once {@link ChilduppPropertiesService} has been initialized, calling this
 * method will throw.
 *
 * @param {Object} config - Update object to be recursively merged with the
 *                        last stored configuration.
 */
export function setConfig(config) {
    if (initialized)
        throw new Error('Can\'t change the values of the ChilduppProperties after the service has been instanciated');
    merge(storedConfig, config);
}

/**
 * Retrieves the last stored config via {@link setConfig} as an inmutable
 * object.
 * @return {Object}
 */
export function getConfig() {
    return Object.freeze(merge({}, storedConfig));
}

/**
 * Provides acces to the ChilduppProperties. Said properties can be setted before
 * the angular application has been bootstraped by calling {@link setConfig}. Afterwards
 * said config can be accessed via this service as an inmutable object.
 */
export class ChilduppPropertiesService {
    static $serviceName = 'childuppProperties';

    _config = {
        ID: 0,
        UPPLICATION_SERVICES: {
            URL_API_REST: "",
            URL_UMETADATA: "",
            URL_ANALYTICS: "",
        },
        FIREBASE_CONFIG: {
            apiKey: "",
            authDomain: "",
            databaseURL: "",
            projectId: "",
            storageBucket: "",
            messagingSenderId: "",
        },
    };

    constructor() {
        initialized = true;
        this._config = Object.freeze(merge({}, this._config, storedConfig));
    }

    /**
     * Returns the current childupp properties as an inmutable object.
     * @return {ChilduppParameters}
     */
    get() {
        return this._config;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/childupp-properties.service.js